const Title = ({ tagline, heading, subheading, animate }) => {
  return (
    <div className="title">
      {tagline && (
        <p className={`title__tagline animate slide-up ${animate ? 'visible' : ''}`}>
          {tagline}
        </p>
      )}
      {heading && (
        <h1 className={`title__heading animate scale-in delay-1 ${animate ? 'visible' : ''}`}>
          {heading}
        </h1>
      )}
      {subheading && (
        <p className={`title__subheading animate slide-up delay-2 ${animate ? 'visible' : ''}`}>
          {subheading}
        </p>
      )}
    </div>
  )
}

export default Title 